export default __webpack_public_path__ + "static/media/calendar-o.3991678f.svg";